module.exports = __webpack_public_path__ + "static/media/gta.c6d82789.png";